export const FILE = {
  DOWNLOAD: 'DOWNLOAD',
  SETTLEMENTS_FILES: 'SETTLEMENTS_FILES',
  SETTLEMENT_BILLING_ITEMS_FILE: 'SETTLEMENT_BILLING_ITEMS_FILE',
  DOCUMENTS: 'DOCUMENTS',
  REPORT_FILE: 'REPORT_FILE',
  REPORT_DOWNLOAD: 'REPORT_DOWNLOAD',
};
